"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalTagKeys = void 0;
var ExternalTagKeys;
(function (ExternalTagKeys) {
    ExternalTagKeys["DB_INSTANCE_IDENTIFIER"] = "dbinstanceidentifier";
    ExternalTagKeys["DB_NAME"] = "dbname";
    ExternalTagKeys["FUNCTION_NAME"] = "functionname";
    ExternalTagKeys["KOA_HTTP_STATUS_CODE"] = "http.status_code";
    ExternalTagKeys["KOA_HTTP_STATUS_CLASS"] = "http.status_class";
    ExternalTagKeys["KOA_RESOURCE_NAME"] = "resource_name";
    ExternalTagKeys["LAMBDA_COLD_START"] = "cold_start";
    ExternalTagKeys["QUEUE_NAME"] = "queuename";
    ExternalTagKeys["RESOURCE_NAME"] = "resource_name";
    ExternalTagKeys["STEP_FUNCTION_NAME"] = "statemachinename";
})(ExternalTagKeys = exports.ExternalTagKeys || (exports.ExternalTagKeys = {}));
//# sourceMappingURL=externalTagKeys.js.map